import { snakeCase } from 'lodash';

export enum ExpenseEvents {
  ExpenseCreate = 'expense_create',
  ExpenseUpdate = 'expense_update',
  ExpenseDelete = 'expense_delete',
}

export const ExpenseEventsMap: Record<string, string> = Object.keys(
  ExpenseEvents,
).reduce((acc, key) => {
  acc[snakeCase(key).toUpperCase()] = ExpenseEvents[key];

  return acc;
}, {} as Record<string, string>);
